(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-list-carousel-dots-2"] && !Shopify.designMode) return;
  try {
    function initResourceListCarouselDots(root) {
    var scope = root || document;
    var carousels = scope.querySelectorAll('slideshow-component.resource-list__carousel');

    carousels.forEach(function (carousel) {
      if (carousel.dataset.resourceDotsInitialized === 'true') return;

      var dots = Array.from(carousel.querySelectorAll('.resource-list-carousel__dot'));
      if (!dots.length) return;

      function syncDots(index) {
        var activeIndex = 0;

        dots.forEach(function (dot, dotIndex) {
          var slideIndex = Number(dot.dataset.slideIndex || 0);
          if (index >= slideIndex) {
            activeIndex = dotIndex;
          }
        });

        dots.forEach(function (dot, dotIndex) {
          dot.setAttribute('aria-selected', String(dotIndex === activeIndex));
        });
      }

      carousel.dataset.resourceDotsInitialized = 'true';
      carousel.addEventListener('slideshow:select', function (event) {
        syncDots(Number(event.detail.index || 0));
      });

      syncDots(Number(carousel.getAttribute('initial-slide') || 0));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initResourceListCarouselDots(document);
    });
  } else {
    initResourceListCarouselDots(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initResourceListCarouselDots(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["resource-list-carousel"] && !Shopify.designMode) return;
  try {
    function initResourceListCarouselDots(root) {
    var scope = root || document;
    var carousels = scope.querySelectorAll('slideshow-component.resource-list__carousel');

    carousels.forEach(function (carousel) {
      if (carousel.dataset.resourceDotsInitialized === 'true') return;

      var dots = Array.from(carousel.querySelectorAll('.resource-list-carousel__dot'));
      if (!dots.length) return;

      function syncDots(index) {
        var activeIndex = 0;

        dots.forEach(function (dot, dotIndex) {
          var slideIndex = Number(dot.dataset.slideIndex || 0);
          if (index >= slideIndex) {
            activeIndex = dotIndex;
          }
        });

        dots.forEach(function (dot, dotIndex) {
          dot.setAttribute('aria-selected', String(dotIndex === activeIndex));
        });
      }

      carousel.dataset.resourceDotsInitialized = 'true';
      carousel.addEventListener('slideshow:select', function (event) {
        syncDots(Number(event.detail.index || 0));
      });

      syncDots(Number(carousel.getAttribute('initial-slide') || 0));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initResourceListCarouselDots(document);
    });
  } else {
    initResourceListCarouselDots(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initResourceListCarouselDots(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
